import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "phoneLinkFilled"
const PhoneLinkFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M8.25 18C8.871 18 9.375 18.504 9.375 19.125S8.871 20.25 8.25 20.25 7.125 19.746 7.125 19.125 7.629 18 8.25 18" />
          <path
            fillRule="evenodd"
            d="M13.5 1.5C14.328 1.5 15 2.172 15 3V7.403C14.638 7.39 14.268 7.463 13.92 7.634 12.807 8.186 12.351 9.535 12.902 10.649 13.057 10.96 13.138 11.329 13.124 11.707 13.112 12.037 13.03 12.351 12.892 12.62L12.831 12.732C12.197 13.799 12.547 15.18 13.616 15.815 14.049 16.073 14.534 16.165 15 16.116V21C15 21.828 14.328 22.5 13.5 22.5H3L2.847 22.492C2.09 22.415 1.5 21.777 1.5 21V3C1.5 2.172 2.172 1.5 3 1.5zM3 21H13.5V17.25H3zM6.75 3.75C6.336 3.75 6 4.086 6 4.5S6.336 5.25 6.75 5.25H9.75C10.164 5.25 10.5 4.914 10.5 4.5S10.164 3.75 9.75 3.75z"
            clipRule="evenodd"
          />
          <path d="M18.33 4.72C18.629 4.433 19.104 4.444 19.39 4.742 20.26 5.65 20.947 6.724 21.415 7.904 21.884 9.084 22.125 10.35 22.125 11.625S21.884 14.165 21.415 15.345 20.26 17.602 19.39 18.509C19.104 18.807 18.63 18.817 18.33 18.53 18.03 18.244 18.02 17.77 18.308 17.47 19.04 16.705 19.623 15.796 20.02 14.793S20.626 12.713 20.626 11.625 20.42 9.46 20.021 8.457C19.624 7.454 19.042 6.545 18.309 5.78 18.02 5.481 18.03 5.006 18.33 4.72" />
          <path d="M16.504 6.502C16.84 6.26 17.309 6.338 17.55 6.675 18.572 8.102 19.123 9.837 19.125 11.615 19.127 13.396 18.579 15.13 17.561 16.56 17.32 16.897 16.85 16.976 16.515 16.736S16.099 16.027 16.34 15.69C17.174 14.52 17.627 13.09 17.625 11.617 17.623 10.145 17.167 8.717 16.33 7.547 16.09 7.212 16.167 6.744 16.504 6.503" />
          <path d="M14.793 8.91C15.11 8.858 15.439 9.015 15.59 9.318 15.97 10.085 16.153 10.95 16.12 11.815S15.846 13.528 15.41 14.263C15.313 14.425 15.166 14.537 15 14.591L14.994 14.594Q14.924 14.615 14.852 14.624L14.84 14.626Q14.807 14.629 14.775 14.629H14.762Q14.692 14.63 14.622 14.616L14.603 14.613Q14.533 14.598 14.463 14.566L14.453 14.563Q14.418 14.546 14.382 14.525C14.025 14.314 13.908 13.853 14.12 13.497 14.424 12.984 14.6 12.384 14.623 11.761 14.645 11.14 14.513 10.523 14.246 9.983 14.096 9.68 14.169 9.327 14.4 9.107Q14.466 9.044 14.549 8.999 14.566 8.988 14.585 8.978 14.63 8.956 14.678 8.941L14.698 8.934Q14.741 8.92 14.784 8.913z" />
        </svg>
      }
    </span>
  )
}
export default PhoneLinkFilledIcon
